import { Injectable } from '@angular/core';
import { NavItem } from '@app/interfaces/nav-item';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  navItems$$ = new Subject<NavItem[]>();
  navItems$: Observable<NavItem[]> = this.navItems$$.asObservable();

  setNavItems(navItems: NavItem[]): void {
    this.navItems$$.next(navItems);
  }
}
